"use strict";

// Class definition
var KTSigninGeneral = function () {
  // Elements
  var form;
  var submitButton;
  var validator;

  // Handle form
  var handleForm = function (e) {
    // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
    validator = FormValidation.formValidation(
      form,
      {
        fields: {
          'email': {
            validators: {
              regexp: {
                regexp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'The value is not a valid email address',
              },
              notEmpty: {
                message: 'Email address is required'
              }
            }
          },
          'password': {
            validators: {
              notEmpty: {
                message: 'The password is required'
              }
            }
          }
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger(),
          bootstrap: new FormValidation.plugins.Bootstrap5({
            rowSelector: '.fv-row',
            eleInvalidClass: '',  // comment to enable invalid state icons
            eleValidClass: '' // comment to enable valid state icons
          })
        }
      }
    );

    // Handle form submit
    submitButton.addEventListener('click', function (e) {
      // Prevent button default action
      e.preventDefault();

      // Validate form
      validator.validate().then(function (status) {
        if (status == 'Valid') {
          // Show loading indication
          submitButton.setAttribute('data-kt-indicator', 'on');

          // Disable button to avoid multiple click
          submitButton.disabled = true;

          const csrfElement = form.querySelector('input[name="_token"]');

          fetch(form.getAttribute('action'), {
            method: form.getAttribute('method'),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': csrfElement ? csrfElement.value : '',
            },
            body: JSON.stringify(Object.fromEntries((new FormData(form)).entries()))
          })
            .then((response) => {
              if (response.ok) {
                var redirectUrl = form.getAttribute('data-kt-redirect-url');

                window.location.href = redirectUrl ?? '/';
              } else {
                Swal.fire({
                  text: "Niepoprawnie wypełniony formularz.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "OK!",
                  customClass: {
                    confirmButton: "btn btn-primary"
                  }
                });
              }
            })
            .finally(() => {
              // Hide loading indication
              submitButton.removeAttribute('data-kt-indicator');

              // Enable button
              submitButton.disabled = false;
            });
        } else {
          // Show error popup. For more info check the plugin's official documentation: https://sweetalert2.github.io/
          Swal.fire({
            text: "Niepoprawnie wypełniony formularz.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "OK!",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          });
        }
      });
    });
  }

  // Public functions
  return {
    // Initialization
    init: function () {
      form = document.querySelector('#kt_sign_in_form');
      submitButton = document.querySelector('#kt_sign_in_submit');

      handleForm();
    }
  };
}();

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTSigninGeneral.init();
});
